import { CompetitionMarketingFormCmsContent, Steps } from '../../types/cms/competition-marketing-form'

/**
 * Competition Marketing Form
 * @param {CompetitionMarketingFormCmsContent} content - The content configuration for the competition marketing form, which includes form fields, checkboxes, and stepper form subtext.
 * @returns {StepConfiguration} an object with the steps to show in the form and the total number of steps, based on the content configuration.
 */
export const getStepperConfiguration = (content: CompetitionMarketingFormCmsContent) => {
    const {formFields, formCheckboxes} = content
    const steps: Steps[] = [] // sort type
    const hasCheckboxes = formCheckboxes?.firstCheckbox?.firstCheckboxDescription?.description
    const hasAddressOrCheckboxes = formFields?.address || hasCheckboxes
    
    if (formFields?.name) {
      // Name fields (if required)
      steps.push({
        fields: ['firstname', 'lastname'],
        subText: content?.stepper?.stepperForm?.stepperFormSubtext?.nameFieldSubtext
      })
    }
      
    // Email + phone (if required)
    const emailPhoneFields = ['email']
    const emailPhoneFieldsSubText = [content?.stepper?.stepperForm?.stepperFormSubtext?.emailFieldSubtext]
    if (formFields?.phoneNumber) {
      emailPhoneFields.push('phone')
      if (content?.stepper?.stepperForm?.stepperFormSubtext?.phoneFieldSubtext) {
        emailPhoneFieldsSubText.push(content?.stepper?.stepperForm?.stepperFormSubtext?.phoneFieldSubtext)
      }
    }
    steps.push({
      fields: emailPhoneFields,
      subText: emailPhoneFieldsSubText
    })
      
    // Address + checkboxes (if required)
    if (hasAddressOrCheckboxes) {
      const addressCheckboxFields: string[] = []
      if (formFields?.address) {
        addressCheckboxFields.push('address')
      }
      if (hasCheckboxes) {
        addressCheckboxFields.push('checkboxes')
      }
      steps.push({
        fields: addressCheckboxFields,
        subText: content?.stepper?.stepperForm?.stepperFormSubtext?.addressFieldSubtext
      })
    }
    return {
      steps,
      totalSteps: steps.length
    }
  }